import moment from "moment";
import { getRole } from "../../../Utils/types";

export const initialStateFilter = {
  page: 1,
  rows: 10,
  providerId: 0,
  flag: "N",
  caseNo: "",
  fromDate: moment(new Date()).format("YYYY-MM-DD"),
  toDate: moment(new Date()).format("YYYY-MM-DD"),
  sortDirection: "asc",
  id: 0,
  clientName: null,
  customerName: null,
  mobileNumber: null,
  status: "A,P,N,E,C,K",
  providerName: null,
  FilterPresetName: "todayAppointment",
};

export const IbuExcelHeader = [
  { label: "Case Id/Policy Number", key: "caseId" },
  { label: "Customer/Proposer Name", key: "customerName" },
  { label: "Email Id", key: "emailId" },
  { label: "Appoinment Date", key: "AppoinmentDate" },
  { label: "Appoinment Time", key: "AppoinmentTime" },
  { label: "Visit Type", key: "visitType" },
  { label: "Customer Address", key: "customerAddress" },
  { label: "Gender", key: "gender" },
  { label: "Mobile Number", key: "mobileno" },
  { label: "Client Name", key: "clientName" },
  { label: "Package Name", key: "packageName" },
  { label: "Tests", key: "tests" },
  { label: "Status", key: "status" },
  { label: "Additional Test", key: "additionalTest" },
  { label: "Date Of Birth", key: "dob" },
];
export const IbuExcelNetworkHeader = [
  { label: "Case Id/Policy Number", key: "caseId" },
  { label: "Customer/Proposer Name", key: "customerName" },
  { label: "Email Id", key: "emailId" },
  { label: "Appoinment Date", key: "AppoinmentDate" },
  { label: "Appoinment Time", key: "AppoinmentTime" },
  { label: "Visit Type", key: "visitType" },
  { label: "Customer Address", key: "customerAddress" },
  { label: "Gender", key: "gender" },
  { label: "Mobile Number", key: "mobileno" },
  { label: "Provider Name", key: "providername" },
  { label: "Client Name", key: "clientName" },
  { label: "Package Name", key: "packageName" },
  { label: "Tests", key: "tests" },
  { label: "Status", key: "status" },
  { label: "Additional Test", key: "additionalTest" },
  { label: "Date Of Birth", key: "dob" },
];

export const CSVData = (getAppoinmentExcelDetail) =>
  getAppoinmentExcelDetail?.map((ele) => {
    return {
      caseId: ele?.caseNo,
      customerName: ele?.proposerName,
      emailId: ele?.email,
      AppoinmentDate: ele?.appointmentDate,
      AppoinmentTime: ele?.appointmentTime,
      visitType: ele?.visit,
      customerAddress: ele?.address,
      gender: ele?.gender,
      mobileno: ele?.mobileno,
      providername: ele?.providername,
      clientName: ele?.clientName,
      packageName: ele?.packageName,
      tests: ele?.tests,
      status: ele?.status,
      additionalTest: ele?.additionalTest,
      dob: moment(ele?.dob).format("Do MMMM YYYY")
    };
  });

export const styleTopSecBackgroundColor = (type) => {
  return type === "Pending"
    ? "#ffe2ab"
    : type === "Approved" ||
      type === "Completed" ||
      type === "Report Pending" ||
      type === "Report On Hold" ||
      type === "Confirmed" || type === "Partial Show"
    ? "#5157a0"
    : type === "Expired"
    ? "#dbdbdb"
    : (type === "Rejected" || type === "No Show" || type === "Cancelled" ) &&
      "#FFC9B3";
};

export const styleTopSecColor = (type) => {
  return type === "Pending"
    ? "#ffa800"
    : type === "Approved" ||
      type === "Completed" ||
      type === "Report Pending" ||
      type === "Report On Hold" || 
      type === "Confirmed" || type === "Partial Show"
    ? "white"
    : type === "Expired"
    ? "#575757"
    : (type === "Rejected" || type === "No Show" || type === "Cancelled" ) &&
      "#FF4D00";
};
export const styleCustomerColor = (type) => {
  return type === "Pending"
    ? "#ffa800"
    : type === "Approved" ||
      type === "Completed" ||
      type === "Report Pending" ||
      type === "Report On Hold" ||
      type === "Confirmed" || type === "Partial Show"
    ? "#5157a0"
    : type === "Expired"
    ? "#575757"
    : (type === "Rejected" || type === "No Show" || type === "Cancelled" ) &&
      "#FF4D00";
};

export const selectOptionStatus = [
  {
    value: "A",
    label: "Accepted",
  },
  {
    value: "R",
    label: "Rejected",
  },
  {
    value: "P",
    label: "Pending",
  },
  {
    value: "S",
    label: "Report Pending",
  },
  {
    value: "H",
    label: "Report On Hold",
  },
  {
    value: "U",
    label: "Completed",
  },
  {
    value: "N",
    label: "No Show",
  },
  {
    value: "E",
    label: "Expired",
  },
  {
    value: "C",
    label: "Cancelled",
  },
  {
    value: "K",
    label: "Confirmed",
  },
  {
    value: "Z",
    label: "Partial Show",
  },
];

export const PrintDropdownDetails = [
  {
    heading: "Today’s Appointments",
    funnelType: "todayAppointment",
    status: "A,P,N,E,C,K",
    fromDate: moment(new Date()).format("YYYY-MM-DD"),
    toDate: moment(new Date()).format("YYYY-MM-DD"),
  },
  {
    heading: "Upcoming Appointments",
    funnelType: "upcomingAppointment",
    status: null,
    fromDate: moment().add(1, "days").format("YYYY-MM-DD"),
    toDate: moment().add(30, "days").format("YYYY-MM-DD"),
  },
  {
    heading: "Pending Confirmation",
    funnelType: "pendingConfirmation",
    status: "P",
    fromDate: moment(new Date()).format("YYYY-MM-DD"),
    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
  },
  {
    heading: "Pending ReportUpload",
    funnelType: "reportPending",
    status: "S,H",
    fromDate:
      getRole() === "NetworkAdmin"
        ? moment(new Date()).format("YYYY-MM-DD")
        : moment().subtract(30, "days").format("YYYY-MM-DD"),
    toDate: moment(new Date()).format("YYYY-MM-DD"),
  },
  {
    heading: "Partial Show",
    funnelType: "partialShow",
    status: "Z",
    fromDate:
      getRole() === "NetworkAdmin"
        ? moment(new Date()).format("YYYY-MM-DD")
        : moment().subtract(30, "days").format("YYYY-MM-DD"),
    toDate: moment(new Date()).format("YYYY-MM-DD"),
  },
  {
    heading: "Closed Appointments",
    funnelType: "completed",
    status: "U",
    fromDate:
      getRole() === "NetworkAdmin"
        ? moment(new Date()).format("YYYY-MM-DD")
        : moment().subtract(30, "days").format("YYYY-MM-DD"),
    toDate: moment(new Date()).format("YYYY-MM-DD"),
  },
];

export const ReasonTypeHAPortal = [
  "Customer Lapse",
  "DC Lapse",
  "HA Lapse",
  "Insurer Lapse",
];
export const ReasonTypeHAProduct = ["HA Lapse", "DC Lapse", "Customer Lapse"];
